import React, { useState, useEffect } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import './ManageApplyFor.css';

export default function ManageApplyFor() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newName, setNewName] = useState('');
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');
  const [adding, setAdding] = useState(false);
  const [showAddRow, setShowAddRow] = useState(false);

  useEffect(() => { loadOptions(); }, []);

  const loadOptions = async () => {
    try {
      const data = await api.applyForOptions.list();
      setOptions(data);
    } catch (err) {
      toast.error('Failed to load options');
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (!newName.trim()) { toast.error('Please enter a name'); return; }
    setAdding(true);
    try {
      await api.applyForOptions.create({ name: newName.trim() });
      toast.success('Option added successfully');
      setNewName('');
      setShowAddRow(false);
      loadOptions();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to add option');
    } finally {
      setAdding(false);
    }
  };

  const handleUpdate = async (id) => {
    if (!editName.trim()) { toast.error('Please enter a name'); return; }
    try {
      await api.applyForOptions.update(id, { name: editName.trim() });
      toast.success('Option updated successfully');
      setEditId(null);
      loadOptions();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update option');
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';
    try {
      await api.applyForOptions.update(id, { status: newStatus });
      toast.success('Status updated');
      loadOptions();
    } catch (err) {
      toast.error('Failed to update status');
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm('Are you sure you want to delete "' + name + '"?')) return;
    try {
      await api.applyForOptions.delete(id);
      toast.success('Option deleted successfully');
      loadOptions();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to delete option');
    }
  };

  if (loading) {
    return (
      <div className="maf-container">
        <div className="maf-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="maf-container">
      <div className="maf-header">
        <h2>Manage Apply For Options</h2>
        <button className="maf-add-btn" onClick={() => setShowAddRow(true)}>
          + Add New Option
        </button>
      </div>

      <div className="maf-table-wrapper">
        <table className="maf-table">
          <thead>
            <tr>
              <th style={{width: '60px'}}>#</th>
              <th>Apply For</th>
              <th style={{width: '120px'}}>Status</th>
              <th style={{width: '150px'}}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {showAddRow && (
              <tr className="maf-add-row">
                <td>-</td>
                <td>
                  <input
                    type="text"
                    className="maf-input"
                    placeholder="Enter option name"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                    autoFocus
                  />
                </td>
                <td><span className="maf-badge active">Active</span></td>
                <td>
                  <button className="maf-action-btn save" onClick={handleAdd} disabled={adding}>
                    {adding ? '...' : 'Save'}
                  </button>
                  <button className="maf-action-btn cancel" onClick={() => { setShowAddRow(false); setNewName(''); }}>
                    Cancel
                  </button>
                </td>
              </tr>
            )}
            {options.map((opt, index) => (
              <tr key={opt.id}>
                <td>{index + 1}</td>
                <td>
                  {editId === opt.id ? (
                    <input
                      type="text"
                      className="maf-input"
                      value={editName}
                      onChange={(e) => setEditName(e.target.value)}
                      onKeyDown={(e) => e.key === 'Enter' && handleUpdate(opt.id)}
                      autoFocus
                    />
                  ) : (
                    opt.name
                  )}
                </td>
                <td>
                  <span
                    className={'maf-badge ' + (opt.status === 'active' ? 'active' : 'inactive')}
                    onClick={() => handleToggleStatus(opt.id, opt.status)}
                    style={{ cursor: 'pointer' }}
                  >
                    {opt.status === 'active' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  {editId === opt.id ? (
                    <>
                      <button className="maf-action-btn save" onClick={() => handleUpdate(opt.id)}>Save</button>
                      <button className="maf-action-btn cancel" onClick={() => setEditId(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="maf-action-btn edit" onClick={() => { setEditId(opt.id); setEditName(opt.name); }}>Edit</button>
                      <button className="maf-action-btn delete" onClick={() => handleDelete(opt.id, opt.name)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {options.length === 0 && !showAddRow && (
              <tr><td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#94a3b8' }}>No options found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
